{
    "alerts": {
        "AN_ERROR_OCCURRED": "Se ha poducido un error. Por favor, inténtelo de nuevo.",
        "ANCHOR_TAB_STRING_NOT_FOUND": "Cada firmante debe firmar al menos un documento.",
        "DUPLICATE_SIGNER_ERROR": "Los firmantes duplicados deben tener la misma opción de firma.",
        "DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR": "Email y teléfono de cada interviniente debe ser único y no puede repetirse, excepto para CB/SC o firma por poder. En ese caso por favor marque esta casilla",
        "DUPLICATE_EMAIL_MOBILE_SIGNER_LEGAL_COMPLIANCE": "Al marcar la casilla para casos de CB/Sc o firma por poder usted confirma que no se trata de una suplantación de identidad por parte de ningún interviniente, con las implicaciones legales correspondientes",
        "EMAIL_AND_PHONE_MANDATORY": "Todos los firmantes deben tener una dirección de correo electrónico y un número de teléfono móvil",
        "EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE": "No se puede crear un sobre para esta propuesta porque no se ha enviado a crédito",
        "GENERIC_ERROR": "La creación del sobre falló debido a un error desconocido.",
        "GUARANTOR_WARNING_MESSAGE": "Los paquetes que incluyen garantes no están autorizados para Diseño",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "Dirección de correo electrónico proporcionada para el/los firmante/s no es válida",
        "MANDATORY_FIELD_FOR_SIGNER_ERROR": "Todos los firmantes deben tener una dirección de correo electrónico y un número de teléfono móvil",
        "NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN": "Su usuario no tiene acceso a los módulos Seguimiento de propuestas o Firma electrónica.",
        "NO_DOCUMENT_SELECTED": "Seleccione al menos un documento.",
        "NO_ENVELOPE_FOUND": "No se ha encontrado ningún sobre para la propuesta.",
        "NO_MODULE_ASSIGNED": "Ningún módulo asignado",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA": "No hay propuestas disponibles para los criterios de búsqueda dados.",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR": "No hay propuestas disponibles para los criterios de búsqueda dados. Haga clic en el botón BORRAR para ver todos los registros.",
        "NO_RESULTS_FOUND": "No se han encontrado resultados",
        "NO_SIGNED_DOCUMENTS_AVAILABLE": "No hay documentos disponibles para este sobre.",
        "NO_SIGNER_DOCUMENT_SELECTED_ACTION": "Por favor, seleccione al menos un documento y un firmante para crear un sobre.",
        "NO_SIGNER_OR_DOCUMENT_SELECTED": "Ningún firmante/documento seleccionado",
        "NO_SIGNER_SELECTED": "Por favor seleccione al menos un firmante.",
        "SEARCH_FOR_A_PROPOSAL_TO_CONTINUE": "Busque una propuesta para continuar.",
        "START_DATE_WARNING_MESSAGE": "La fecha de inicio de este contrato es anterior a su firma, lo que lo dejaría sin efecto. Verifique la fecha y asegúrese de que la firma sea anterior o la misma que la fecha de inicio del contrato.",
        "INVALID_PRODUCT_WARNING": "Esign no está disponible para arrendamiento y alquiler de productos"

    },
    "docusignErrorMessages": {
        "ANCHOR_TAB_STRING_NOT_FOUND": "El punto de firma no se encontró en el documento",
        "INVALID_EMAIL_ADDRESS": "Dirección de correo electrónico no válida",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "La dirección de correo electrónico del destinatario no es válida.",
        "PHONE_NUMBER_INVALID": "El número de teléfono no es válido."
    },
    "labels": {
        "ACTION": "Accion",
        "ADD": "Añadir",
        "ADD_NEW_SIGNER": "Añadir nuevo firmante",
        "ADD_NEXT": "Añadir siguiente",
        "ADD_SIGNER": "Añadir firmante",
        "ADMIN_UTILITY": "Admin Utility",
        "APPROVED": "Aprobado",
        "APPROVED_WITH_CONDITIONS": "Aprobado con condiciones",
        "ASSOCIATE": "Comprador",
        "ASSOCIATED_PARTIES": "Compradores",
        "AUTO_APPROVED": "Aprobado automáticamente",
        "AWAITING_FURTHER_INFORMATION_DOCUMENTS": "En espera de documentación",
        "BACK_TO_DASHBOARD": "Volver al inicio",
        "BULK_EREGISTRY_UTILITY": "Utilidad E-Registry masiva",
        "BUNDLE": "Presupuesto",
        "CLEAR": "Borrar",
        "CO-BORROWER": "Segundo Comprador",
        "COMBINED": "Conjunto",
        "COMPLETED": "Completado",
        "CONTRACT_PAID_OFF": "Contrato pagado",
        "COUNTRY": "País",
        "CREATE_ENVELOPE": "Crear Sobre",
        "CREATED": "Creado",
        "CREATED_DATE": "Fecha de creacion",
        "CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW": "Propuesta enviada a revisión manual",
        "DEALER": "Concesión",
        "DEALER_REFERENCE": "Referencia del concesionario",
        "DEALERSHIP_NAME": "Concesionario",
        "DECLINED": "Denegado",
        "DECLINED_DATE": "Fecha de denegacións",
        "DECLINED_REASON": "Motivo de la denegación",
        "DELETED": "Eliminado",
        "DELIVERED": "Entregado",
        "DOCUMENT_NAME": "Nombre del documento",
        "DOCUMENTS": "Documentos",
        "DOCUMENTS_SELECTED": "documentos seleccionados",
        "DOWNLOAD": "Descargar",
        "E_SIGNATURE": "Firma Digital",
        "E_SIGNATURE_DASHBOARD": "Firma Digital - Pantalla de Inicio",
        "EMAIL": "Email",
        "ENVELOPE_ID": "Número de identificación del sobre",
        "ENVELOPE_REVIEW": "Revision del Sobre",
        "E-REGISTRY_DOWNLOAD": "Registro",
        "EXAMPLE_PHONE_NUMBER": "Ex. +34 123456789",
        "EXPIRED": "Caducado",
        "FETCHING_DOCUMENTS_FOR": "Obtención de documentos para",
        "GERMANY": "Alemania",
        "GET_STATUS": "Actualizar estado",
        "GUARANTOR": "Avalista",
        "HI": "Hola",
        "ICS_REFERENCE": "Numero de contrato",
        "ISD_CODE_IS_REQUIRED": "Se requiere prefijo de país",
        "JDF_SIGNER": "Firmante JDF",
        "MATURITY_DATE": "Fecha de vencimiento",
        "MERGER_AND_ACQUISITION": "Fusiones y Adquisiciones",
        "MOBILE": "Móvil",
        "NAME": "Nombre",
        "NO_DECLINING_REASON_PROVIDED": "No se proporcionó el motivo de la denegación",
        "NOT_AVAILABLE": "No disponible",
        "NOT_SIGNED": "No firmado",
        "NOT_VIEWED": "No visto",
        "OF": "de",
        "ON_DEMAND": "Bajo demanda",
        "OPTION": "Opción",
        "OPTIONS": "Opciones",
        "ORDER": "Posicion",
        "PRIMARY": "Comprador",
        "PRIMARY_CUSTOMER": "Nombre del Cliente",
        "PROCESSING": "Procesando",
        "PRODUCT": "Producto",
        "PROPOSAL": "Propuesta",
        "PROPOSAL_DETAILS": "Detalles de la propuesta",
        "PROPOSAL_TRACKING": "Seguimiento de propuestas",
        "PROPOSED": "Propuesto",
        "QUOTE": "Estructura Financiera",
        "QUOTE_STATUS": "Estado",
        "REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE": "c. Estos detalles no se pueden actualizar una vez que se envía el sobre.",
        "REVIEW_MESSAGE_ISD_CODE": "b. El número de móvil debe inlcuir el prefijo de país para todos los firmantes. Ejemplo: +34 123456789",
        "REVIEW_MESSAGE_OTP": "a. Cada firmante se autenticará a través de una contraseña de un solo uso (OTP) enviada al número de móvil que se proporciona a continuación.",
        "ROLE": "Posición",
        "SALESPERSON": "Vendedor",
        "SAVE_&_ADD_NEXT_SIGNER": "Guardar y agregar el siguiente firmante",
        "SAVE_SIGNER": "Guardar firmante",
        "SEARCH": "Buscar",
        "SELECT_DOCUMENTS": "Selección de documentos",
        "SELECTED_DOCUMENTS": "Documentos en el sobre",
        "SELECT_THIRD_PARTY": "Seleccionar tercero",
        "SEND_ENVELOPE": "Enviar sobre",
        "SENDING_ENVELOPE": "Enviando sobre",
        "SENT": "Enviado",
        "SENT_/_VIEWED": "Enviado / Visto",
        "SENT_DATE": "Fecha de Envío",
        "SEPARATE": "Separado",
        "SIGN_BY_EMAIL": "Firmar por correo electrónico",
        "SIGN_NOW": "Firmar ahora",
        "SIGNED": "Firmado",
        "SIGNED_DATE": "Fecha de Firma",
        "SIGNER": "Firmante",
        "SIGNERS": "Firmantes",
        "SIGNING_OPTION": "Opción de firma",
        "SIGNING_ORDER": "Orden de firma",
        "SIGNING_ORDER_PREVIEW": "Vista previa del orden de firma",
        "SIGNING_STATUS": "Estado de firma",
        "PORTUGAL": "Portugal",
        "SPAIN": "España",
        "START_DATE": "Fecha de Inicio",
        "STATUS": "Estado",
        "STATUS_DATE": "Fecha de estado",
        "SUBMITTED": "Presentada",
        "TEMPLATE": "Modelo",
        "THIRD_PARTY": "Tercero",
        "UNDELIVERABLE": "Sin enviar",
        "UNITED_KINGDOM": "Reino Unido",
        "UPDATING_STATUS": "Actualizando Estado",
        "VIEWED": "Visto",
        "VIEWED_DATE": "Fecha de vista",
        "VOIDED": "Anulado",
        "WITHDRAWN": "Retirado",
        "PRIMARY_QUOTE": "Propuesta procesada",
        "ENVELOPE_SENT_UNDER_PROCESS": "El sobre ha sido enviado. Por favor espere a que el proceso se complete",
        "ENVELOPE_SUCCESSFULLY_SENT": "El sobre ha sido enviado correctamente",
        "ADD_PROXY": "Añadir representante",
        "PROXY": "representantes",
        "ADD_NEW_PROXY": "Añadir nuevo representante",
        "you can only assign": "Sólo puede asignar",
        "representatives to the": "representantes como máximo a la",
    },
    "messages": {
        "BUNDLE_NUMBER_NOT_FOUND": "No se encontró ningún resultado porque no hay estructuras financieras asociadas a este número de presupuesto.",
        "CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE": "por favor, cree este firmante como un firmante bajo demanda",
        "DOCUMENT_DOWNLOAD_FAILED": "La descarga del documento desde S3 falló.",
        "ICS_NUMBER_NOT_FOUND": "No se encontró ningún resultado porque no hay estructuras financieras asociadas a este número de contrato.",
        "INVALID_BUNDLE_NUMBER": "El número de presupuesto introducido no es válido. Por favor, introduzca uno válido y vuelva a internarlo.",
        "INVALID_ICS_NUMBER": "El número de contrato proporcionado no es válido. Por favor, introduzca uno válido y vuelva a internarlo.",
        "INVALID_PRIMARY_CUSTOMER": "El nombre del cliente proporcionado no es válido. Por favor, introduzca uno válido y vuelva a internarlo.",
        "INVALID_QUOTE_NUMBER": "El número de estructura financiera introducido no es válido. Por favor, introduzca uno válido y vuelva a internarlo.",
        "PRIMARY_CUSTOMER_NOT_FOUND": "No se encontró ningún resultado porque el cliente no existe en el sistema.",
        "QUOTE_NUMBER_NOT_FOUND": "No se encontró ningún resultado porque el número de presupuesto y el de la estructura financiera no están relacionados."
    },
    "products": {
        "DPFR_24_MONTH_LOAN_STOCK_DE": "DPFR - 24 month Loan Stock DE",
        "DPFR_LOAN_DE": "DPFR - Loan DE",
        "DPFR_LOAN_STOCK_DE": "DPFR - Loan Stock DE",
        "DPFR_NON_FULL_PAYOUT_LEASE_DE": "DPFR - Non Full Payout Lease DE",
        "DPFR_OPERATING_LEASE_DE": "Operating Lease DE",
        "LOAN_DE": "Loan DE",
        "NON_FULL_PAYOUT_LEASE_DE": "Non Full Payout Lease DE",
        "OPERATING_LEASE_DE": "Operating Lease DE"
    }
}
